import { brand, footer } from '@/content/site'

import { Reveal } from './shared/Reveal'

function Wordmark() {
  return (
    <span className="font-sans text-base font-semibold tracking-tight text-ink select-none">
      <span className="text-iris">◆</span>
      <span className="ml-1.5">{brand.wordmark}</span>
    </span>
  )
}

export function FooterSection() {
  return (
    <footer className="relative overflow-hidden pb-14 pt-8 md:pb-20">
      <div className="shell">
        {/* CTA band */}
        <Reveal>
          <div className="glass glass-rim glass-hi relative overflow-hidden p-8 text-center md:p-14">
            <div
              className="pointer-events-none absolute -top-24 left-1/2 h-56 w-[36rem] -translate-x-1/2 opacity-60"
              style={{
                background:
                  'radial-gradient(ellipse at center, rgb(167 139 250 / 0.35), transparent 70%)',
                filter: 'blur(40px)',
              }}
              aria-hidden="true"
            />

            <h2 className="relative mx-auto max-w-2xl font-sans text-[1.6rem] md:text-[2.2rem] font-semibold tracking-[-0.02em] leading-tight">
              {footer.headline}
            </h2>

            <p className="relative mx-auto mt-4 max-w-xl font-paragraph text-[0.95rem] leading-relaxed text-ink-dim">
              {footer.blurb}
            </p>

            <div className="relative mt-8 flex flex-wrap items-center justify-center gap-3">
              <a href={footer.ctaPrimary.href} className="btn btn-primary focus-ring">
                {footer.ctaPrimary.label}
              </a>
              <a href={footer.ctaSecondary.href} className="btn btn-glass focus-ring">
                {footer.ctaSecondary.label}
              </a>
            </div>
          </div>
        </Reveal>

        {/* Link columns */}
        <div className="mt-14 grid grid-cols-2 gap-8 md:grid-cols-4">
          <Reveal i={0}>
            <div>
              <Wordmark />
              <p className="mt-3 max-w-[16rem] font-paragraph text-[0.8rem] leading-relaxed text-ink-mute">
                {brand.description}
              </p>
            </div>
          </Reveal>

          {footer.columns.map((col, i) => (
            <Reveal key={col.title} i={i + 1}>
              <div>
                <h3 className="font-mono text-[0.58rem] uppercase tracking-[0.18em] text-aqua">
                  {col.title}
                </h3>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="font-paragraph text-[0.85rem] text-ink-dim transition-colors hover:text-ink"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Legal */}
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/8 pt-6 md:flex-row">
          <p className="font-paragraph text-[0.75rem] text-ink-mute">{footer.copyright}</p>
          {/* Text, not links — no policy pages exist yet. */}
          <div className="flex items-center gap-5">
            {footer.legal.map((label) => (
              <span key={label} className="font-paragraph text-[0.75rem] text-ink-mute">
                {label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
